import React, { useContext, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  renderTicketReadmoreDetails,
} from "../../utils/common/common";
import Attachments from "../feedback/attachments";
import PreviewImageModal from "../feedback/previewAttachmentModal";
import { Http, appLogger } from "../../utils";

const MediaAttachments = (props: any) => {
  const { detailRow, pageType } = props;
  const [openImgPrvModal, setOpenImgprvw] = useState(false);
  const [ImgUrl, setImgUrl] = React.useState("");
  const [attachmentType, setAttachmentType] = React.useState("");

  const getSignedUrl = (url: string) => {
    return new Promise<string>((resolve, reject) => {
      const pattern = "s3.amazonaws.com/";
      const name = encodeURIComponent(
        url?.substring(url?.indexOf(pattern) + pattern.length)
      ); //.replace('/', '%2F');
      Http.get({
        url: `/api/v2/signedurl/${name}`,
      })
        .then((response: any) => {
          if (response.filePath) {
            appLogger.info({
              infoObj: {
                method: "getSignedUrl",
                component: "feedback",
                fileName: "filter.tsx",
                filePath: response.filePath,
              },
            });
            return resolve(response.filePath);
          }
        })
        .catch((error) => {
          props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "getSignedUrl",
              component: "feedback",
              fileName: "filter.tsx",
              err: error,
            },
          });
          return reject(error);
        });
    });
  };
  const viewAttachmentClicked = async (
    attachmentData: string,
    type: string
  ) => {
    const url = await getSignedUrl(attachmentData);
    if (url) {
      setOpenImgprvw(true);
    }
    setImgUrl(url);
    setAttachmentType(type);
  };
  const closeImgPrvModalFn = () => {
    setOpenImgprvw(false);
  };
  return (
    <Box className="user-reports tickets">
      {detailRow?.feedbackMedia &&
        Object.keys(detailRow.feedbackMedia).length > 0 && (
          <Accordion defaultExpanded>
            <AccordionSummary
              aria-controls={"panel1-content"}
              id={"panel1-header"}
            >
              <Typography className="title-sm1 accordianTitle">
                Attachments
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {detailRow.feedbackMedia &&
              Object.keys(detailRow.feedbackMedia).length > 0 ? (
                <Attachments
                  media={detailRow.feedbackMedia}
                  getSignedUrl={getSignedUrl}
                  viewAttachmentClicked={viewAttachmentClicked}
                />
              ) : (
                <div>
                  <Typography className="info no-attach">
                    No attachment
                  </Typography>
                </div>
              )}
            </AccordionDetails>
          </Accordion>
        )}
      {detailRow?.attachment && (
        <Attachments
          media={detailRow.attachment}
          getSignedUrl={getSignedUrl}
          viewAttachmentClicked={viewAttachmentClicked}
        />
      )}
      {attachmentType && attachmentType.length > 0 && (
        <PreviewImageModal
          attachmentUrl={ImgUrl}
          datas={detailRow}
          openAttachmentPrvModal={openImgPrvModal}
          closeAttachmentPrvModal={closeImgPrvModalFn}
          attachmentType={attachmentType}
        />
      )}
    </Box>
  );
};

export default withSnackbar(MediaAttachments);
